export const T = {
  en_GB: {
    equals: "Equals",
    notEquals: "Not Equals",
    greaterThan: "Greater Than",
    lessThan: "Less Than",
    isEmpty: "Is Empty",
    isNotEmpty: "Is Not Empty",
  },
  nb_NO: {
    equals: "Er lik",
    notEquals: "Er ikke lik",
    greaterThan: "Større enn",
    lessThan: "Mindre enn",
    isEmpty: "Er tom",
    isNotEmpty: "Er ikke tom",
  },
} as const;
